<template>
  <div>
    <v-chip
      v-if="
        isDecimal({
          number: cantidadPromocion({
            articulo: codArt,
            data: PromocionAll,
            numpromocion: codPromo,
          }),
        })
      "
      class="ma-2"
      label
      color="error"
      small
    >
      Error. verifique los datos de la promoción
    </v-chip>

    <div v-else>
      <template>
        <v-btn
          class="rounded-0 ma-2 body-1 font-weight-bold text-uppercase"
          color="primary"
          style="border: 4px solid #d3bc8d"
          label
          @click="
            selPromo(codArt, codPromo);
            GetTipoPromo(codArt, codPromo) === 'Combo Especial'
              ? ((dialogTipoPromo = true), cargarPromoCombo())
              : cantPromo(codArt, codPromo);
          "
          outlined
          text-color="primary"
          small
          :loading="estatusAdd"
          v-if="Cliente.showOpc === false && dataUser.IndAutenticado === true"
        >
          <span>{{ titulo }} </span>
        </v-btn>
      </template>
    </div>

    <v-chip small label v-if="estatusAdd">
      <v-icon dark color="primary">mdi-information</v-icon>
      <span>Agregando Articulo...</span>
    </v-chip>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from "vuex";

  export default {
    name: "btnSelPromo",
    data() {
      return {
        dialogTipoPromo: false,
        datosPromo: [],
        estatusAdd: false,
      };
    },
    methods: {
      ...mapMutations(["SET_DATOS_ART_PROMO_CANT"]),
      ...mapActions([
        "cargarDatosPromoCombo",
        "consolidadoSCategoriaCar",
        "set_cargaArtCarrito",
        "cargarDatosArtCar",
        "get_ConsultaPedido",
      ]),
      formatNumber(num) {
        return parseFloat(num).toFixed(2);
      },
      TotalPrecio(Cantidad, Precio, Descuento, TipoMoneda) {
        var Total = 0;
        Total = Cantidad * Precio;
        if (Descuento != 0) {
          Total = Total - Total * (Descuento / 100);
        }

        if (TipoMoneda == 0) {
          return Total;
        } else if (TipoMoneda == 1) {
          return Total;
        }
      },
      async cantPromo(id, codp) {
        let cantMin = this.cantidadPromocion({
          articulo: id,
          data: this.PromocionAll,
          numpromocion: codp,
        });

        this.SET_DATOS_ART_PROMO_CANT(cantMin);
        this.estatusAdd = true;
        await this.set_cargaArtCarrito({
          articulo: id,
          cantidad: this.formatNumber(
            this.contCantidad({
              contmayor: this.infoproducto.ContentMayor,
              cant: cantMin,
            })
          ),
          promo: codp,
        });
        await this.cargarDatosArtCar({ codart: id });
        await this.get_ConsultaPedido();
        this.estatusAdd = false;
      },
      cargarPromoCombo() {
        if (this.datosPromo.codigo != 0)
          this.cargarDatosPromoCombo({ CodigoPromo: this.datosPromo[0].codigo });
      },
    },
    computed: {
      ...mapState([
        "PromocionAll",
        "Articulo",
        "ttArticuloAll",
        "DetalleArt",
        "Cliente",
        "tipoMoneda",
        "dataUser",
        "PromocionCombo",
        "VerPrecios",
        "Pedido",
      ]),
      isDecimal: function () {
        return function ({ number }) {
          return !Number.isInteger(number);
        };
      },
      cantidadPromocion: function () {
        return function ({ articulo, data, numpromocion }) {
          const cantMin = data
            .filter(
              (x) => x["articulo"] === articulo && numpromocion === x["codigo"]
            )
            .map((x) => x["cantidad-min"]/x["ContenidoMayor"]);

          return cantMin[0];
        };
      },
      contCantidad: function () {
        return function ({ contmayor, cant }) {
          // return this.validaContenido ? contmayor * cant : cant;
          return contmayor * cant;
        };
      },
      color: function () {
        return function (idp) {
          return idp === false ? "#D32F2F" : "#2E7D32";
        };
      },
      GetTipoPromo: function () {
        return function (id, codp) {
          if (this.PromocionAll)
            return this.PromocionAll.filter(
              (x) => x["articulo"] === id && x["codigo"] === codp
            )
              .map((x) => x["TipoPromo"])
              .toString();
        };
      },
      selPromo: function () {
        return function (id, codp) {
          this.datosPromo = [];
          const p = this.PromocionAll.filter(
            (x) => x["articulo"] === id && codp === x["codigo"]
          );
          const indexPromo = this.PromocionAll.findIndex(
            (x) => x["articulo"] === id && codp === x["codigo"]
          );

          if (p.length > 0) {
            this.$emit("sel-promo", p);
            this.datosPromo = p;
          
          } 
        };
      },
    },
    props: {
      titulo: String,
      codArt: String,
      tipoConsulta: Number,
      codPromo: Number,
      unidad: String,
      infoproducto: Object | Array,
    },
  };
</script>

<style scoped>
  .img_art2 {
    max-width: 60%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .v-cardgrid {
    background-color: #ffffff !important;

    border: 1px solid #fe5000 !important;

    transition: opacity 0.4s ease-in-out;
    margin: 1px;
  }
</style>
